/* eslint-disable */
const dashPendingFitments = {
  dashboard_uid: 'dashPendingFitments',
  name: 'Pending Fitments',
  fullscreen: true,
  content: {}
}

export default dashPendingFitments
